module.exports = __webpack_public_path__ + "img/login-main.eff625dd.png";